import {
    Button,
    Card, CardContent, CardHeader, Typography
} from '@material-ui/core'
import * as React from 'react'
import { useHistory } from 'react-router-dom'

import map from '../../assets/map.png'
import { getPuzzle } from '../../services/puzzles-services'
import { formatTimeline, useInvokeEffect } from '../../utils/helper'
import { PuzzleDto, PuzzleHeaderDto } from '../../utils/types'
import { PuzzleDetailsModal } from './PuzzleDetailsModal'

interface Props {
    puzzle: PuzzleHeaderDto
    selected?: boolean,
    onSelect?(seconds: number): void
}

export const PuzzleCardView: React.FC<Props> = ({
    puzzle: puzzleHeader,
    selected,
    onSelect,
}) => {
    const [showMore, setShowMore] = React.useState(false)
    const [puzzle, setPuzzle] = React.useState<PuzzleDto>()
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const history = useHistory()

    useInvokeEffect(async () => {
        if (showMore) {
            setPuzzle(
                await getPuzzle(puzzleHeader.puzzleId)
            )
        }
    }, [showMore], {
        operation: 'Loadingen Detailen'
    })

    return (
        <div>
            <Card style={{
                backgroundImage:
                    `linear-gradient(rgba(0,0,0,0.6),rgba(0,0,0,0.6)), url(${puzzleHeader.materialImage || map})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPosition: 'top',
                minWidth: 'calc(30vw * 0.54 - 2%)',
                height: '30vh',
                borderRadius: 8,
                display: 'flex',
                justifyContent: 'space-between',
                flexDirection: 'column',
                margin: '15px',
            }}>
                <CardHeader
                    title={puzzleHeader.puzzleId}
                    subheader={formatTimeline(puzzleHeader.seconds)}/>

                <CardContent>
                    <Typography variant="body2" />
                </CardContent>
                <Button
                    onClick={() => setShowMore(true)}
                    style={{ backgroundColor: '#33949E', color: 'white', padding: 10 }}>
                    Se Opgaver
                </Button>
            </Card>

            {puzzle && (
                <PuzzleDetailsModal
                    answersImage={puzzle.answersImage}
                    videoUri={puzzle.videoUri}
                    materialImage={puzzle.materialImage}
                    materialKey={puzzle.materials?.[0]?.key}
                    materialUri={puzzle.materials?.[0]?.uri}
                    selected={selected}
                    onSelect={onSelect && ((s) => {
                        setShowMore(false)
                        onSelect(s)
                    })}
                    seconds={puzzle.seconds}
                    open={showMore}
                    title={puzzle.puzzleId}
                    description={puzzle.description}
                    onClose={() => setShowMore(false)}/>
            )}
        </div>
    )
}

PuzzleCardView.defaultProps = {
    onSelect: undefined,
    selected: false
}
